import { ApiService } from '@libs-uuif/shared/api-service';
import moment from 'moment';
import { sessionStorageKeeperService } from '../auth-service';
import aws4 from 'aws4';
import AWS from 'aws-sdk';

const urlPostfix = '/api/v2';
export class WcmApiService {
  wcmApiWrapper = new ApiService();

  getAuthStorage(baseUrl: string, headers: any) {
    const wcmBaseUrl = `${baseUrl}${urlPostfix}`;
    this.wcmApiWrapper = new ApiService(wcmBaseUrl);
    return this.wcmApiWrapper.get<any>('/user/auth/mysonicwall', {
      ...headers,
    });
  }

  getSsoToken(data: any) {
    return this.wcmApiWrapper.post<any>('/auth/sso', data);
  }

  getApiData(endpoint: string, params: any, data: any = null) {
    const wcmSession = sessionStorageKeeperService.retrieveJSON('wcmSession');
    let tenantId = '';
    if (
      wcmSession &&
      wcmSession.ssoKeys &&
      wcmSession.ssoKeys.tenants &&
      wcmSession.ssoKeys.tenants.length > 0
    ) {
      tenantId = wcmSession.ssoKeys.tenants[0].tenant_id || '';
    }
    return this.wcmApiWrapper.get<any>(`/tenants/${tenantId}${endpoint}`, {
      params,
      headers: this.doSign(
        'GET',
        `/tenants/${tenantId}${endpoint}`,
        data,
        params,
      ).headers,
    });
  }

  deleteReport(endpoint: string, data: any = null) {
    return this.wcmApiWrapper.post<any>(endpoint, data, {
      headers: this.doSign('POST', endpoint, data, '').headers,
    });
  }
  deleteReportWithDelete(endpoint: string, data: any = null) {
    return this.wcmApiWrapper.delete<any>(endpoint, {
      headers: this.doSign('DELETE', endpoint, data, '').headers,
    });
  }
  editReportData(endpoint: string, data: any = null) {
    return this.wcmApiWrapper.patch<any>(endpoint, data, {
      headers: this.doSign('PATCH', endpoint, data, '').headers,
    });
  }
  deleteMultipleReportWithDelete(endpoint: string, data: any = null) {
    return this.wcmApiWrapper.post<any>(endpoint, data , {
      headers: this.doSign('POST', endpoint, data, '').headers,
    });
  }

  createReport(endpoint: string, data: any = null) {
    return this.wcmApiWrapper.post<any>(endpoint, data, {
      headers: this.doSign('POST', endpoint, data, '').headers,
    });
  }

  getXAmzDate() {
    const date = `${moment.utc()
      .format('YYYYMMDD[T]HHmmss[Z]')}`;
    return date;
  }
  getXAmzToken() {
    const wcmSession = sessionStorageKeeperService.retrieveJSON('wcmSession');
    return wcmSession.ssoKeys.credentials.session_token;
  }

  getAbsolutePath(endpoint: string, config: any) {
    const searchParams = new URLSearchParams();
    Object.keys(config)
    .forEach(key => searchParams
      .append(key, config[key]));
    return `${endpoint}?${searchParams.toString()}`;
  }

  downloadWirelessReport(reportName: any, url: any, wirelessReportDownload?:boolean) {
    const wcmSession = sessionStorageKeeperService.retrieveJSON('wcmSession');
    let tenantId = '';
    let regionForDownload;
    try {
      regionForDownload = url.split('.')[1];
    } catch (error) {
      console.error('Wireless Report Download Url Error', error);
      return;
    }
    if (
      wcmSession &&
      wcmSession.ssoKeys &&
      wcmSession.ssoKeys.tenants &&
      wcmSession.ssoKeys.tenants.length > 0
    ) {
      tenantId = wcmSession.ssoKeys.tenants[0].tenant_id || '';
    }
    const s3 = new AWS.S3();
    AWS.config.update({
      secretAccessKey: wcmSession.ssoKeys.credentials.secret_key,
      accessKeyId: wcmSession.ssoKeys.credentials.access_key,
      sessionToken: wcmSession.ssoKeys.credentials.session_token,
      region: regionForDownload as string,
    });

    const myBucket = url && new URL(url).pathname.split('/')[1];
    const myKey = `tenant-reports/${tenantId}/${reportName}`;
    const signedUrlExpireSeconds = 3600 * 24; //  expiry time in seconds.
    try {
      const signedDownloadUrl = s3.getSignedUrl('getObject', {
        Bucket: myBucket,
        Key: myKey,
        Expires: signedUrlExpireSeconds,
      });
      window.open(signedDownloadUrl, '_blank');
    } catch (error) {
      // Added this condition to handle error which occurs on very first download wireless report of page load
      if (
        error.message.includes('AWS_CONFIG_FILE') && !wirelessReportDownload) {
        this.downloadWirelessReport(reportName, url, true);
      } else {
        console.error('Wireless Report Download Error', error);
      }
    }
  }

  doSign(signMethod: string, endpoint: string, data: any, config: any) {
    const wcmSession = sessionStorageKeeperService.retrieveJSON('wcmSession');
    if (
      wcmSession &&
      wcmSession.ssoKeys &&
      wcmSession.ssoKeys.credentials &&
      wcmSession.ssoKeys.api_endpoint
    ) {
      const absPath = this.getAbsolutePath(endpoint, config);
      const apiGatewayStage = wcmSession.ssoKeys.api_stage || '';
      const hostToSign = wcmSession.ssoKeys.api_endpoint || '';
      const pathToSign = `${apiGatewayStage}/api/v2${absPath}`;
      const headerToSign = {};
      let regionToSign = '';
      try {
        regionToSign = wcmSession.ssoKeys.api_endpoint.split('.')[2] as string;
      } catch (error) {
        console.error('Wireless API Region Error', error);
      }

      const optToSign: any = {
        host: hostToSign,
        method: signMethod.toUpperCase(),
        path: pathToSign,
        service: 'execute-api',
        region: regionToSign,
        headers: headerToSign,
      };
      if (data) {
        Object.assign(optToSign, {
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
          },
        });
      }
      aws4.sign(optToSign, {
        secretAccessKey: wcmSession.ssoKeys.credentials.secret_key || '',
        accessKeyId: wcmSession.ssoKeys.credentials.access_key || '',
        sessionToken: wcmSession.ssoKeys.credentials.session_token || '',
      });
      delete optToSign.headers['Host'];
      delete optToSign.headers['Content-Length'];
      return optToSign;
    }
    return { headers: {} };
  }

  activateTenant(endpoint: string, params: any, data: any = null) {
    return this.wcmApiWrapper.get<any>(endpoint, {
      params,
      headers: this.doSign('GET', endpoint, data, params).headers,
    });
  }
}

export const wcmApiService = new WcmApiService();
